export default __webpack_public_path__ + "80bbb09de252da5902f531fe5288f86e.png";